import {ApplicationService} from './../../../services/application.service';
import {
    Component,
    OnInit,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    QueryList,
    AfterViewInit,
    AfterContentInit,
    ChangeDetectorRef
} from '@angular/core';
import { environment } from '../../../../environments/environment';

import {ToastrService} from 'ngx-toastr';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {RouteService} from 'app/services/route.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {PopupService} from '../../../services/shared/popup.service';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {UploaddocumentComponent} from '../../../uploaddocument/uploaddocument.component';
import {AddRouteComponent} from '../add-route/add-route.component';
import {BehaviorSubject} from 'rxjs';
import {CarrierService} from 'app/services/carrier.service';
import {FilterService} from '../../../shared/filter/filter.service';
import {AuthWebService} from '../../../services/authweb.service';
import {FormBuilder, FormGroup} from '@angular/forms';


@Component({
    selector: 'app-ext-route-list',
    templateUrl: './ext-route-list.component.html',
    styleUrls: ['./ext-route-list.component.css']
})
export class ExtRouteListComponent implements OnInit {
    routes: any = [];

    message = 'Loading Standard Routes...';
    public isLoading = false;
    showNum: number = 4;
    lblHeading = 'Standard Routes';
    isEmpty: boolean = false;
    @Input() dataCntrl: any;
    @Output() previousStep = new EventEmitter<number>();
    @Output() nextStep = new EventEmitter<number>();
    @Input() renewal: boolean = false;
    @Input() crId: number;
    @Input() permitId: number;
    isExternalRole: boolean = true;
    numberOfStops: number = 0;
    applicationid: number = 0;
    carrierId: number;
    isAdmin: boolean = false;
    routeList: any;
    routeSelectedFromList: any;
    onStartUp: boolean;
    @Input() hideHeader = true;
    isView: boolean = false;
    private user: any;
    userRouteSelected: any;
    selectRouteId: any;
    goBack() {
        this.previousStep.emit(3);
    }
    routeForm: FormGroup;
    selectedRoute: any;

    goNextStep() {
        this.savedSelectedRoute();

    }

    selectedRouteId: number = 0;
    @Output() tryOutTextRoutes = new EventEmitter<string>();

    getTextRoutes() {
        this.tryOutTextRoutes.emit('TextRoute');
    }

    @ViewChild('addRouteComponent', {static: false})
    editRouteComponent: AddRouteComponent;
    // addRouteComponents: QueryList<AddRouteComponent>;
    //@ViewChild(AddRouteComponent, { static: false }) editRouteComponent: AddRouteComponent;
    constructor(private routeService: RouteService, private toastService: ToastNotificationService,private fb: FormBuilder, private applicationService: ApplicationService, private authWebService: AuthWebService,
                private showModal: PopupService, private toastr: ToastrService, private carrierService: CarrierService, private filter: FilterService,
                private routr: Router, public utility: UtilityServiceService, private changeDetector: ChangeDetectorRef) {

    }

    ngOnInit() {

        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
            this.isAdmin = true;
      
        }
        this.routeForm = this.fb.group({
            ListSelectedRoute_id: [''] // Replace '' with the default value you want to set
        });

        this.user = this.authWebService.userData
            ? this.authWebService.userData.User
            : null;

        this.utility.setDirection(true);
        if (this.dataCntrl || !this.hideHeader) {

            try {
                this.isLoading = true;
                if (this.dataCntrl?.application?.carrierID === undefined) {
                    if (this.dataCntrl?.application?.applicationID !== undefined) {
                        this.applicationService.getById(this.dataCntrl?.application?.id).subscribe(x => {
                            this.dataCntrl = x;
                            if (this.dataCntrl?.carrier?.transport_assoc_id === undefined || this.dataCntrl?.carrier?.transport_assoc_id === null) {
                                //fetch carrier details if null
                                let carrierId = this.dataCntrl?.carrierID ? this.dataCntrl?.application?.carrierID : null;
                                this.carrierId = carrierId;
                                if (carrierId != null) {
                                    this.carrierService.getById(carrierId).subscribe(result => {
                                        this.dataCntrl.carrier = result;
                                        this.getRoutes();
                                    }, error => {
                                        console.error(error);
                                    });
                                } else {
                                    this.getRoutes();
                                }

                            } else {
                                this.getRoutes();
                            }
                        });
                    } else {
                        this.getRoutes();
                    }
                } else {
                    this.getRoutes();
                }
            } catch (e) {
                console.error(e)
            }


            this.applicationid = this.dataCntrl?.application.id;
            this.selectedRoute = this.dataCntrl?.application.route;
        }

        if (this.selectedRoute === undefined || this.selectedRoute === null) {
            this.getRouteApplication();
        } else {
            this.assignTypeValues();
        }

        if (this.routr.url.indexOf('view') != -1) {
            this.isView = true;
        }

        if (!this.authWebService.userData.Roles[0].IsExternalRole) {
            this.isExternalRole = false;
        }

        console.log('Route dataCntrl', this.dataCntrl);
    }

    setRouteMapCoordinates(route: any) {
        if (route) {
            if (route.route_leg?.length > 0) {
                var first_route = route.route_leg.find(x => x.step_num === 1);
                if (first_route) {
                    route.source = {

                        lat: first_route.place_from_data?.latitude,
                        lng: first_route.place_from_data?.longitude,

                    }
                }
                var second_route = route.route_leg.find(x => x.step_num === 99);

                if (second_route) {
                    route.destination = {

                        lat: second_route.place_to_data?.latitude,
                        lng: second_route.place_to_data?.longitude,

                    }
                }
            }
        }
    }

    getRouteApplication() {
        if (this.applicationid !== undefined && this.applicationid !== null) {
            try {
                this.routeService.getRouteByApplication(this.applicationid).subscribe((route) => {
                    this.selectedRoute = route;
                    this.assignTypeValues();
                }, error => {
                    console.error(error);
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    assignTypeValues() {
        if (this.selectedRoute != undefined || this.selectedRoute != null) {

            this.setRouteMapCoordinates(this.selectedRoute);

            if (this.selectedRoute?.route_type_ind == 1) {
                this.selectedRoute.route_type_ind = 'Standard descriptive';
            }
            if (this.selectedRoute?.route_type_ind == 3) {
                this.selectedRoute.route_type_ind = 'Standard with legs/places';
            }
            if (this.selectedRoute?.route_type_ind == 5) {
                this.selectedRoute.route_type_ind = 'Standard desc & legs';
            }
            if (this.selectedRoute?.route_type_ind == 11) {
                this.selectedRoute.route_type_ind = 'Carrier-defined descriptive';
            }
            if (this.selectedRoute?.route_type_ind == 13) {
                this.selectedRoute.route_type_ind = 'Carrier-defined with legs/places';
            }
            if (this.selectedRoute?.route_type_ind == 15) {
                this.selectedRoute.route_type_ind = 'Carrier-defined desc & legs';
            }
            if (this.selectedRoute?.freight_passenger_ind == 1) {
                this.selectedRoute.freight_passenger_ind = 'Freight';
            }
            if (this.selectedRoute?.freight_passenger_ind == 2) {
                this.selectedRoute.freight_passenger_ind = 'Passenger';
            }
            if (this.selectedRoute?.freight_passenger_ind == 3) {
                this.selectedRoute.freight_passenger_ind = 'Both';
            }
            if (this.selectedRoute?.freight_passenger_ind == undefined) {
                this.selectedRoute.freight_passenger_ind = 'None';
            }

            console.log('Final Selected Route', this.selectedRoute);
        }
    }

    getRoutes() {
        this.isLoading = true;
        let taxi_association_id = this.dataCntrl?.carrier?.transport_assoc_id;
        if (!taxi_association_id) {
            taxi_association_id = 0;
        }
        let cargo_ind = this.dataCntrl?.permit_type?.freight_passenger_ind;
        let filter_object = {
            'RouteName': '',
            'ProvinceId': 0,
            'DestinationCountry': 0,
            'showTranxAssociationOnly': taxi_association_id != 0 ? true : null,
            'tranxassociationId': taxi_association_id,
            'passenger_freight_id': cargo_ind //TO DO:
        }
        this.onStartUp = true;
        this.getRoutesByFilters(filter_object);
        //OLD CODE

        //  this.routeService.getRouteByTaxiAssociation(taxi_association_id,cargo_ind).subscribe(data => {
        //      this.routes = data;
        //      //add the selected route to the route list but to the top of the array

        //      // if (this.selectedRoute !== undefined) {
        //      //     this.routes.unshift(this.selectedRoute);
        //      // }
        //      console.log('Routes List', this.routes);

        //      for (let index = 0; index < this.routes.length; index++) {

        //          let element = this.routes[index];
        //          this.setRouteMapCoordinates(element);
        //          let stops = element.route_leg?.filter(x => x.is_from_stop_spot).length;
        //          element.numberOfStops = stops;
        //          if (element.route_type_ind == 1) {
        //              element.route_type_ind = 'Standard descriptive';
        //          }
        //          if (element.route_type_ind == 3) {
        //              element.route_type_ind = 'Standard with legs/places';
        //          }
        //          if (element.route_type_ind == 5) {
        //              element.route_type_ind = 'Standard desc & legs';
        //          }
        //          if (element.route_type_ind == 11) {
        //              element.route_type_ind = 'Carrier-defined descriptive';
        //          }
        //          if (element.route_type_ind == 13) {
        //              element.route_type_ind = 'Carrier-defined with legs/places';
        //          }
        //          if (element.route_type_ind == 15) {
        //              element.route_type_ind = 'Carrier-defined desc & legs';
        //          }
        //          if(element.freight_passenger_ind == 1)
        //              element.freight_passenger_ind = "Freight";
        //          if(element.freight_passenger_ind == 2)
        //              element.freight_passenger_ind = "Passenger";
        //          if(element.freight_passenger_ind == 3)
        //              element.freight_passenger_ind = "Both";
        //          if(element.freight_passenger_ind == undefined)
        //              element.freight_passenger_ind = "None";
        //          this.routes[index] = element;
        //      }
        //      this.isLoading = false;
        //      this.isEmpty = (this.routes.length == 0) ? true : false;
        //// this.utility.onSort(5);
        //}, error => {
        //   this.isLoading = false;
        //   this.isEmpty = true;
        // });
    }

    onConfirm(id) {

        this.showModal.showConfirm('Delete Standard Route', 'Are you sure you want to delete?', `You're about to delete Standard Route`, 'Yes', 'No')
            .subscribe((isConfirmed) => {
                if (isConfirmed) {
                    this.delete(id)
                } else {
                    return;
                }
            });

    }

    selectRoute(route: any) {
        this.selectedRouteId = route.id;
        if (this.renewal) {
            console.log('Renewal Permit', this.selectedRouteId);
            this.routr.navigate([`route/management/edit/${route.id}/${this.applicationid}/${this.crId}/${this.permitId}`]);
        } else {
            this.routr.navigate([`route/management/edit/${route.id}/${this.applicationid}`]);
        }

    }

    selectRouteToApplication(route: any) {
        console.log('checked route', route)
        this.userRouteSelected = route;
        // this.selectedRouteId = route.id;
    }
    savedSelectedRoute() {
        if(this.userRouteSelected){
            this.isLoading = true;
            var body ={
                routeId : this.userRouteSelected.id,
                applicationId : this.applicationid,
                user: this.user.FirstName + ' ' + this.user.LastName,
            }

            this.routeService.addRouteApplication(body).subscribe((data: any) => {
                console.log("Selected ",data);
                this.isLoading = false;
                this.toastService.success("Route added to application", "Permit Details");
                this.dataCntrl.application.route_id = data.id;
                this.nextStep.emit(3)
            }, error => {
                console.log(error);
                this.isLoading = false;
                this.toastService.error("An error occurred while adding route to application", "Permit Details");
            })
        }else if(this.selectedRoute){
            this.isLoading = true;
            setTimeout(() => {
                this.nextStep.emit(3)
            }, 1000);

        }else{
            this.toastService.error("Please first select a route to add to the application", "Permit Details");
        }

    }

    delete(id) {
        this.routeService.deleteRoutes(id).subscribe((x: any) => {
                this.getRoutes();
                this.isLoading = false;
                this.toastService.success('Delete Route', 'Route deleted successfully');
                this.routr.navigateByUrl('/route/management/list');
            },
            error => {
                console.log(error);
                this.isLoading = false;
                this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
                // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                return;
            });
    }

    onItemChange(selectedValue) {
        let routeId = parseInt(selectedValue.split(' ')[1]);
        console.log(routeId);
        this.routes = this.routeList.filter(route => route.id === routeId);
        this.isEmpty = false;

        this.setRouteMapCoordinates(this.routes[0]);

        if (this.routes[0]?.route_type_ind == 1) {
            this.routes[0].route_type_ind = 'Standard descriptive';
        }
        if (this.routes[0]?.route_type_ind == 3) {
            this.routes[0].route_type_ind = 'Standard with legs/places';
        }
        if (this.routes[0]?.route_type_ind == 5) {
            this.routes[0].route_type_ind = 'Standard desc & legs';
        }
        if (this.routes[0]?.route_type_ind == 11) {
            this.routes[0].route_type_ind = 'Carrier-defined descriptive';
        }
        if (this.routes[0]?.route_type_ind == 13) {
            this.routes[0].route_type_ind = 'Carrier-defined with legs/places';
        }
        if (this.routes[0]?.route_type_ind == 15) {
            this.routes[0].route_type_ind = 'Carrier-defined desc & legs';
        }
        if (this.routes[0]?.freight_passenger_ind == 1) {
            this.routes[0].freight_passenger_ind = 'Freight';
        }
        if (this.routes[0]?.freight_passenger_ind == 2) {
            this.routes[0].freight_passenger_ind = 'Passenger';
        }
        if (this.routes[0]?.freight_passenger_ind == 3) {
            this.routes[0].freight_passenger_ind = 'Both';
        }
        if (this.routes[0]?.freight_passenger_ind == undefined) {
            this.routes[0].freight_passenger_ind = 'None';
        }
    }

    toHoursAndMinutes(totalMinutes) {
        const minutes = totalMinutes % 60;
        const hours = Math.floor(totalMinutes / 60);
        return `${hours} h ${minutes > 0 ? ` ${minutes} m` : ''}`;
    }

    onSearch() {

        this.filter.getData().subscribe(data => {

            let taxi_association_id = this.dataCntrl.carrier?.transport_assoc_id;
            if (!taxi_association_id) {
                taxi_association_id = 0;
            }
            let cargo_ind = this.dataCntrl.permit_type.freight_passenger_ind;
            //status filter
            let statutes: any = [];
            data.consultantStatusMultiSelect?.forEach(x => {
                statutes.push(x.desc);
            });

            //roles filter
            let roles: any = [];
            data.consultantRoleMultiSelect?.forEach(x => {
                roles.push(x.id);
            });

            let filter_object = {
                'RouteName': data.routeName ? data.routeName : '',
                'ProvinceId': data.provinceName ? data.provinceName : 0,
                'DestinationCountry': data.destinationCountry ? data.destinationCountry : 0,
                'showTranxAssociationOnly': data.routesDedicatedtoMyTransAssoc ? data.routesDedicatedtoMyTransAssoc : null,
                'tranxassociationId': taxi_association_id,
                'passenger_freight_id': cargo_ind //TO DO:
            }

            this.onStartUp = false;

            this.getRoutesByFilters(filter_object);
            // this.getConsultantsList(this.carrierID, data.consultantUserName, data.consultantStatusMultiSelect != null ? data.consultantStatusMultiSelect[0]?.desc : "", data.consultantRoleMultiSelect  != null ? data.consultantRoleMultiSelect[0]?.id : 0);
        });
    }

    getRoutesByFilters(params) {

        console.log('Route Params', params);
        this.routeService.getRoutesFilter(params).subscribe(data => {
            this.isLoading = false;
            if (!this.onStartUp) {
                this.routes = data;
            }
            this.routeList = data;
            for (let index = 0; index < this.routes.length; index++) {

                let element = this.routes[index];
                this.setRouteMapCoordinates(element);
                let stops = element.route_leg?.filter(x => x.is_from_stop_spot).length;
                element.numberOfStops = stops;
                if (element.route_type_ind == 1) {
                    element.route_type_ind = 'Standard descriptive';
                }
                if (element.route_type_ind == 3) {
                    element.route_type_ind = 'Standard with legs/places';
                }
                if (element.route_type_ind == 5) {
                    element.route_type_ind = 'Standard desc & legs';
                }
                if (element.route_type_ind == 11) {
                    element.route_type_ind = 'Carrier-defined descriptive';
                }
                if (element.route_type_ind == 13) {
                    element.route_type_ind = 'Carrier-defined with legs/places';
                }
                if (element.route_type_ind == 15) {
                    element.route_type_ind = 'Carrier-defined desc & legs';
                }
                if (element.freight_passenger_ind == 1) {
                    element.freight_passenger_ind = 'Freight';
                }
                if (element.freight_passenger_ind == 2) {
                    element.freight_passenger_ind = 'Passenger';
                }
                if (element.freight_passenger_ind == 3) {
                    element.freight_passenger_ind = 'Both';
                }
                if (element.freight_passenger_ind == undefined) {
                    element.freight_passenger_ind = "None";
                }
                this.routes[index] = element;
            }
            this.isEmpty = (this.routes.length == 0);

            console.log('Final Routes List', this.routes);

        }, error => {
            this.isLoading = false;
            this.isEmpty = true;
        });
    };

    cancelApplication() {
        let prevUrl = localStorage.getItem('previousUrl');

        if (prevUrl.search('/permit/approval') != -1) {
            this.routr.navigate(['/permit/approval/']);
        } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
            this.routr.navigate(['/carrier/permit/application/mypermits/', this.dataCntrl.carrierID]);
        } else {
            this.routr.navigate(['/carrier/permit/application/', this.dataCntrl.carrierID]);
        }
    }
}
